import React, { useEffect, useState } from "react";

export default function AdminRejectModal({ open, tx, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  // Reset when opening/closing or tx changes
  useEffect(() => {
    if (!open) {
      setReason("");
      setLoading(false);
      return;
    }
    setReason("");
    setLoading(false);
  }, [open, tx?.reference]);

  if (!open || !tx) return null;

  async function confirm() {
    if (loading) return;
    setLoading(true);
    try {
      await onConfirm?.(reason?.trim() || "");
      onClose?.();
      setReason("");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Rejeter la transaction"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="w-full max-w-lg rounded-2xl bg-white dark:bg-slate-900 shadow-xl border border-black/10 dark:border-white/10 overflow-hidden">
        <div className="p-5 border-b border-black/10 dark:border-white/10">
          <h3 className="text-base font-semibold text-slate-900 dark:text-white">
            Rejeter la transaction
          </h3>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Ref: <b>{tx.reference || "—"}</b>
          </p>
        </div>

        <div className="p-5 space-y-3">
          <label className="block text-sm font-medium text-slate-700 dark:text-slate-200">
            Motif (optionnel)
          </label>

          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
            placeholder="Ex: Paiement non reçu / pièce manquante / incohérence..."
            className={inputCls}
          />

          <div className="text-xs text-slate-500 dark:text-slate-400">
            ⚠️ Si l’opération a mis un <b>hold</b> (withdraw / transfer), le serveur doit libérer le hold à la rejection.
          </div>
        </div>

        <div className="p-5 border-t border-black/10 dark:border-white/10 flex gap-2">
          <button
            type="button"
            onClick={() => onClose?.()}
            className="flex-1 rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-slate-900 py-3 text-sm font-medium
                       text-slate-900 dark:text-white hover:bg-black/5 dark:hover:bg-white/10 transition"
          >
            Annuler
          </button>

          <button
            type="button"
            disabled={loading}
            onClick={confirm}
            className="flex-1 rounded-2xl bg-red-600 text-white py-3 text-sm font-medium hover:opacity-95 transition disabled:opacity-60"
          >
            {loading ? "Rejet..." : "Rejeter"}
          </button>
        </div>
      </div>
    </div>
  );
}

const inputCls =
  "w-full rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-slate-950 px-4 py-3 text-slate-900 dark:text-white outline-none " +
  "focus:ring-2 focus:ring-slate-900/10 dark:focus:ring-white/10";
